import React from 'react';
import ContainerTemplate from '../../../../widgets/template/Container';
import PanelDocentesView from './PanelDocentesView';
import * as ROUTES from '../../../../router/Routes';

const PanelDocentesModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.panelDocentes}
      routes={[ROUTES.controlEstudios, ROUTES.docentes]}
    >
      <PanelDocentesView />
    </ContainerTemplate>
  );
};

export default PanelDocentesModule;
